import { executeFetch } from 'api';

const manualVehicleLookup = (args: { [key: string]: any }): Promise<any> => {
  return executeFetch('vehicles', args);
};

export default manualVehicleLookup;
